import { pcEffects } from './pc/effect.js';

export function calendarEffects() {
  pcEffects();
}
